
/* THF Custom code */
var readMoreBtns = document.querySelectorAll("#readMoreBtn");
var moreTexts = document.querySelectorAll("#TTAmore");

for (var i = 0; i < readMoreBtns.length; i++) {
  readMoreBtns[i].addEventListener("click", function() {
    var moreText = this.nextElementSibling;
    var btnText = this;

    if (moreText.style.visibility !== "visible") {
      btnText.innerHTML = "Read less -"; 
      moreText.style.visibility = "visible";
      moreText.style.height = "auto";
    } else {
      btnText.innerHTML = "Read more +"; 
      moreText.style.visibility = "hidden";
      moreText.style.height = "0";
    }
  });
}